import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/laendergruppen-vorgang/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="DossierCountryGroup"
      returnRoute="/auswahlfelder/dossierCountryGroup"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const DossierCountryGroupRoute = Route;
